<!--
 * @Description  : 学生参与情况-学生参与明细表, 各类课程学生参与明细表
 * @Author       : chenJunHui
 * @LastEditors: chaoluandi chaoluandi@whty.com.cn
 * @Date         : 2022-09-06 14:02:57
 * @LastEditTime: 2024-12-10 10:11:52
 * @FilePath     : \after_class_service\src\pages\cloudMap\proupTable\studentPart.vue
-->
<template>
  <div class="index">
    <!-- <div class="tabs">
      <p :class="{ active: active=='one' }" @click="clickTab('one')">
        学生参与时长明细
      </p>
      <p :class="{ active: active!='one' }" @click="clickTab('two')">
        各类课程学生参与明细
      </p>
    </div> -->
    <div class="table" v-show="active=='one'">
    <el-table
        v-loading="loading"
        :data="dataList"
        style="width: 100%"
        :border="true"
        :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
      >
        <el-table-column
          prop="orga_name"
          label="学校名称"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="全时参与学生占比"
          width="180"
          align="center"
        >
        <template slot-scope="scope">
            <p>
              {{ (scope.row.full_time_stu_per * 100).toFixed(2) }}%
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="部分时间参与学生占比"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{ (scope.row.part_time_stu_per * 100).toFixed(2) }}%
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="未参与学生占比"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{ (scope.row.participate_stu_ef_per * 100).toFixed(2) }}%
            </p>
          </template>
        </el-table-column>
    </el-table>
    <div class="pagination">
        <el-pagination
          background
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total,prev, pager, next,jumper,sizes"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
        ></el-pagination>
      </div>
      <!-- <download-excel class = "export-excel-wrapper" :data = "excelpage" :fields = "json_fields" name = "学生参与情况.xls" >
    		<a-button type="primary" icon="download"> 导出 </a-button>
    </download-excel> -->
    </div>
    <!-- 各类课程学生参与明细 -->
    <div class="table" v-show="active=='two'">
    <el-table
        v-loading="loading"
        :data="dataList_2"
        style="width: 100%"
        :border="true"
        :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
      >
        <el-table-column
          prop="orga_name"
          label="学校名称"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="全时参与学生占比"
          width="180"
          align="center"
        >
        <template slot-scope="scope">
            <p>
              {{ (scope.row.full_time_stu_per * 100).toFixed(2) }}%
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="部分时间参与学生占比"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{ (scope.row.part_time_stu_per * 100).toFixed(2) }}%
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="未参与学生占比"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{ (scope.row.participate_stu_ef_per * 100).toFixed(2) }}%
            </p>
          </template>
        </el-table-column>
    </el-table>
    <div class="pagination">
        <el-pagination
          background
          :current-page="pageNum_2"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize_2"
          :total="total"
          layout="total,prev, pager, next,jumper,sizes"
          @size-change="sizeChangeHandle_2"
          @current-change="currentChangeHandle_2"
        ></el-pagination>
      </div>
      <!-- <download-excel class = "export-excel-wrapper" :data = "excelpage_2" :fields = "json_fields_2" name = "filename.xls" >
    		<a-button type="primary" icon="download"> 导出 </a-button>
    </download-excel> -->
    </div>
  </div>
</template>
<script>
import cloudMapApi from '@/api/cloudMapApi.js';
import { mapMutations, mapState } from 'vuex';
export default {
  props: ["selectParmam",],
  components: {},
  computed:{
    ...mapState(['isSchool']),
  },
  data() {
    return {
      dataList: [],
      dataList_2: [],
      titleObj: {
        one: '学生参与明细表',
        two: '各类课程学生参与明细表',
      },
      active: 'one',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      pageNum_2: 1,
      pageSize_2: 10,
      total_2: 0,
      tabActice: 0,
      tableData: [],
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
      excelpage:[],    // 存放用于导出excel的数据
      json_fields: {
        '学校名称': "orga_name",    //常规字段
        '全时参与学生占比': "full_time_stu_per", //支持嵌套属性
        '部分时间参与学生占比': 'part_time_stu_per',
        '未参与学生占比': "participate_stu_ef_per",
      },
      excelpage_2:[],    // 存放用于导出excel的数据
      json_fields_2: {
        '学校名称': "orga_name",    //常规字段
        '全时参与学生占比': "full_time_stu_per", //支持嵌套属性
        '部分时间参与学生占比': 'part_time_stu_per',
        '未参与学生占比': "participate_stu_ef_per",
      },
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ]
    };
  },
  created() {
    this.getData();
  },
  watch: {
    selectParmam(n, o) {
      this.getData();
    },
  },
  mounted() {},
  methods: {
    ...mapMutations([]),
    clickTab(item) {
      if (this.active != item) {
        this.active = item;
        this.getData();
      }
    },
    async getList() {
      try {
        this.loading = true;
        let params = JSON.parse(JSON.stringify(this.selectParmam));
        params.pagenum = this.pageNum;
        params.pagesize = this.pageSize;
        params.topic = this.org_type == '2' || this.isSchool ? '年级' : '校';
        let res = await cloudMapApi.studentParticipate(params);
        if (res.code == '0') {
          this.dataList = res.data.rows;
          this.total = res.data.total || 0;
          this.getExlData();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async getExlData(){
      try {
        let params={
          ...JSON.parse(JSON.stringify(this.selectParmam)),
          pagenum: this.pageNum,
          pagesize: this.total,
        }
        params.topic = this.org_type == '2' || this.isSchool ? '年级' : '校';
        let res = await cloudMapApi.studentParticipate(params);
        if (res.code == "0") {
          this.excelpage = res.data.rows || [];
          this.excelpage.forEach(item=>{
            item.full_time_stu_per= (item.full_time_stu_per * 100).toFixed(2) + '%';
            item.part_time_stu_per= (item.part_time_stu_per * 100).toFixed(2) + '%';
            item.participate_stu_ef_per= (item.participate_stu_ef_per * 100).toFixed(2) + '%';
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getList_2() {
      try {
        this.loading = true;
        let params = JSON.parse(JSON.stringify(this.selectParmam));
        params.pagenum = this.pageNum_2;
        params.pagesize = this.pageSize_2;
        params.type_name = this.active_1;
        params.topic = this.org_type == '2' || this.isSchool ? '年级' : '校';
        let res = await cloudMapApi.studentParticipateDetail(params);
        if (res.code == '0') {
          this.dataList_2 = res.data.rows;
          this.total_2 = res.data.total || 0;
          console.log('啧啧啧',res)
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async getData() {
      if (this.active === 'one') {
        this.pageNum_1 = 1;
        this.getList();
      } else {
        this.pageNum_2 = 1;
        this.getList_2();
      }
    },
    sizeChangeHandle(val) {
			this.pageSize = val
			this.getList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getList()
		},
    sizeChangeHandle_2(val) {
			this.pageSize_2 = val
			this.getList_2()
		},
		currentChangeHandle_2(val) {
			this.pageNum_2 = val
			this.getList_2()
		},
  },
};
</script>
<style lang="less" scoped>
.index {
  position: relative;
  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>